import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { tempos } from "../../../../common/parameters";
import makePatternOptions from "../../../../common/helpers/makePatternOptions";

import { toggleFilterCategory } from "../../../store/browse/actions";
import { IStateTree } from "../../../store/interfaces";
import Icon from "../../../icon";
import {
    CheckboxThreeWay,
    Select,
    SelectCheckbox,
    InputNumber,
    Label,
    Checkbox,
    TwoInOne,
} from "../../../components/Form";

import getFiltersValue from "../getFiltersValue";
import { Slider, Arrow } from "../commonStyles";
import { IProps } from "../Pitch/interfaces";

import messages from "./messages";

const Rhythm = ({ filters, change }: IProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const isOpen = useSelector((state: IStateTree) => state.browse.filterCategories.rhythm);
    const handleToggleCategory = () => {
        dispatch(toggleFilterCategory("rhythm"));
    }
    return (
        <div>
            <h3 onClick={handleToggleCategory}>
                <FormattedMessage {...messages.rhythm} />
                <Arrow opened={isOpen}>
                    <Icon i="chevron-right" />
                </Arrow>
            </h3>
            {isOpen && (
                <Slider>
                    <div>
                        <Select
                            lightWithValue
                            label={formatMessage(messages.tempoFeel)}
                            name="rhythm.tempo"
                            value={getFiltersValue(filters, "rhythm.tempo") as string}
                            onChange={change}
                            options={tempos(formatMessage)}
                        />
                        <div>
                            <Label>
                                <FormattedMessage {...messages.timeSignature} />
                            </Label>
                            <CheckboxThreeWay
                                label={formatMessage(messages.alternating)}
                                name="rhythm.changingTS"
                                checked={getFiltersValue(filters, "rhythm.changingTS") as boolean}
                                onChange={change}
                            />
                            <TwoInOne style={{ maxWidth: 133 }}>
                                <InputNumber
                                    lightWithValue
                                    name="rhythm.timeSignatureNum"
                                    value={getFiltersValue(filters, "rhythm.timeSignatureNum") as string}
                                    onChange={change as any}
                                />
                                <div className={"Gap"}>/</div>
                                <InputNumber
                                    lightWithValue
                                    name="rhythm.timeSignatureDen"
                                    value={getFiltersValue(filters, "rhythm.timeSignatureDen") as string}
                                    onChange={change as any}
                                />
                            </TwoInOne>
                            {getFiltersValue(filters, "rhythm.changingTS") && (
                                <TwoInOne style={{ maxWidth: 133 }}>
                                    <InputNumber
                                        lightWithValue
                                        name="rhythm.timeSignatureNum2"
                                        value={getFiltersValue(filters, "rhythm.timeSignatureNum2") as string}
                                        onChange={change as any}
                                    />
                                    <div className={"Gap"}>/</div>
                                    <InputNumber
                                        lightWithValue
                                        name="rhythm.timeSignatureDen2"
                                        value={getFiltersValue(filters, "rhythm.timeSignatureDen2") as string}
                                        onChange={change as any}
                                    />
                                </TwoInOne>
                            )}
                        </div>
                        <CheckboxThreeWay
                            label={formatMessage(messages.isUpbeat)}
                            name="rhythm.upbeat"
                            checked={getFiltersValue(filters, "rhythm.upbeat") as boolean}
                            onChange={change}
                        />
                        <SelectCheckbox
                            lightWithValue
                            label={formatMessage(messages.rhythmPatterns)}
                            name="rhythm.patterns"
                            value={getFiltersValue(filters, "rhythm.patterns") as string[]}
                            onChange={change}
                            options={makePatternOptions(formatMessage)}
                            join=", "
                        />
                        <Checkbox
                            label={formatMessage(messages.rhythmPatternsOnly)}
                            name="rhythm.patternsOnly"
                            checked={getFiltersValue(filters, "rhythm.patternsOnly") as boolean}
                            onChange={change}
                        />
                    </div>
                </Slider>
            )}
        </div>
    );
};

export default Rhythm;
